var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCredibilityOrange = function SvgCredibilityOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 26,
    r: 20,
    fill: "url(#credibility-orange_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M43 20v-1a3 3 0 1 0-6 0v2.838A4.387 4.387 0 0 0 40 26c1.792.597 3 2.274 3 4.162V33a3 3 0 1 1-6 0v-1M40 14v2M40 36v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.548 52.214 9.587-5.597c.147-.086.305-.153.47-.2l13.864-3.875c1.077-.3 2.227.337 2.372 1.446.494 3.785-1.613 4.776-8.594 8.736a.713.713 0 0 0-.152 1.124l.554.554a11.966 11.966 0 0 0 5.17 3.04v0c1.413.404 2.887.544 4.35.413l6.094-.544a7.17 7.17 0 0 0 4.409-2.081c5.01-4.988 7.55-6.571 11.067-5.294 1.21.44 1.408 1.998.516 2.927l-9.45 9.847a12 12 0 0 1-6.12 3.42l-13.158 2.846c-.834.18-1.684.272-2.538.272H20.548M9.656 47.47h9.235c.915 0 1.657.763 1.657 1.701v23.115c0 .94-.744 1.702-1.657 1.702H9.656c-.915 0-1.656-.764-1.656-1.702V49.171c0-.94.744-1.702 1.656-1.702ZM14.274 51.923v4.473"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "credibility-orange_svg__a",
    x1: 60.488,
    x2: 19.979,
    y1: 25.382,
    y2: 25.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgCredibilityOrange;